export default class HousingType {
  static get DefaultHousingType(){
    return this.getInstance('defaultHousingType');
  }

  static get SingleFamily() {
    return this.getInstance('singleFamily');
  }

  static get Custom() {
    return this.getInstance('custom');
  }

  static get Luxury() {
    return this.getInstance('luxury');
  }

  static get CondosAndTownHomes() {
    return this.getInstance('condosAndTownHomes');
  }

  static get ModelHomes() {
    return this.getInstance('modelHomes');
  }

  static get Redirect() {
    return this.getInstance('redirect');
  }

  static fromKey(key) {
    const formTypeMap = {
      singleFamily: HousingType.SingleFamily,
      custom: HousingType.Custom,
      luxury: HousingType.Luxury,
      condosAndTownHomes: HousingType.CondosAndTownHomes,
      modelHomes: HousingType.ModelHomes,
      defaultHousingType: HousingType.DefaultHousingType,
    };
    return formTypeMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new HousingType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(HousingType, 'instances', { value: {} });
